import { Component } from "react"
import PropTypes from "prop-types"
import { StatusRow } from "./table_components"
import flatten from "lodash/flatten"

export default class Admin extends Component {
  constructor(props) {
    super(props)
    this.state = {
      admin: this.props.values,
      feedbackItems: this.props.feedbackItems,
    }
    this.tableRow = this.props.tableRow.bind(this)
    this.formatValue = this.props.formatValue.bind(this)
    this.onFeedbackUpdated = this.props.onFeedbackUpdated
    this.feedbackContainer = this.props.feedbackContainer
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({ feedbackItems: nextProps.feedbackItems })
  }

  displayRows(admin) {
    let items = [
      {
        key: `admin-email-${admin.user_id}`,
        name: "Email",
        value: admin.email,
        required: true,
        fieldName: "email",
        transform: value => this.formatValue(value, { type: "email" }),
      },
    ]

    if (admin.type !== "deleted") {
      items.push([
        {
          key: `admin-username-${admin.username}`,
          name: "IFTTT account",
          value: admin.username,
          fieldName: "ifttt_account",
        },
        {
          key: `admin-name${admin.name}`,
          name: "Name",
          value: admin.name,
          fieldName: "name",
        },
        {
          key: `admin-phone-${admin.phone}`,
          name: "Phone",
          value: admin.phone,
          fieldName: "phone",
        },
      ])
    }

    items = flatten(items)

    return items.map(item => {
      let _item = item
      let feedback =
        this.state.feedbackItems && this.state.feedbackItems[item.fieldName]
      _item.feedback = feedback
      _item.pathObjs = [
        "channel",
        "channel_admin_roles",
        admin.id,
        item.fieldName,
      ]
      return this.tableRow(_item)
    })
  }

  render() {
    return (
      <table>
        <tbody>
          {this.props.diffStyle !== "none" && (
            <StatusRow status={this.state.admin.type} />
          )}
          {this.displayRows(this.state.admin)}
        </tbody>
      </table>
    )
  }
}

Admin.propTypes = {
  values: PropTypes.object,
  diffStyle: PropTypes.string,
  tableRow: PropTypes.func,
  formatValue: PropTypes.func,
  feedbackItems: PropTypes.object,
  service: PropTypes.object,
  onFeedbackUpdated: PropTypes.func,
  feedbackContainer: PropTypes.func,
}
